import React from "react";
import { Button, Modal } from "react-bootstrap";
import QuestionSection from "../tabViews/QuestionSection";
import AlgorithmSection from "./AlgorithmSection";
import {
  getAllCategoriesInSection,
  getAllQuestionsInPage,
  getAllPagesInSection,
  getAllPostContentInSection,
  getAllPostContentInPage,
  getAllDataInSection,
  getAllQuestionsInSection,
} from "../data/flowChartData.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/nav.scss";

let questionChecklist = [];
let pageNumber = 0;
let next = false;
const w = window;

class ManagementFlow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: this.getCurrentPage(),
      algorithm: null,
      nextAlgorithm: null,
      visibleQuestions: {},
      shownFentanylPopup: false,
      shownAudPopup: false,
      visibleFentanylPopup: false,
      visibleAudPopup: false
    };

    this.clickedBack = this.clickedBack.bind(this);
    this.clickedNext = this.clickedNext.bind(this);
    this.questionSection = this.questionSection.bind(this);
    this.answerSelected = this.answerSelected.bind(this);
    this.setNextAlgorithm = this.setNextAlgorithm.bind(this);
    this.nextButtonStack = this.nextButtonStack.bind(this);
  }

  answerSelected(category, answer) {
    w[category] = answer;
    this.forceUpdate();
  }

  createCategories(id) {
    if (typeof w[id] === "undefined" && id) {
      w[id] = "";
      w[id + "_v"] = false;
    }
  }

  showNextButton(post) {
    if (post.length) {
      next = false;
      return;
    }

    let show = true;

    Object.values(questionChecklist).forEach((answer) => {
      if (answer === null || answer === "") {
        show = false;
        return;
      }
    });

    if (this.state.algorithm) {
      if (this.state.nextAlgorithm && show) {
        next = show;
      } else {
        next = false;
      }
      return;
    }
    if (
      w["diagnosed_aud"] === "I don't know" ||
      w["diagnosed_boud"] === "I don't know" ||
      w["diagnosed_noud"] === "I don't know"
    ) {
      show = true;
    }
    next = show;
  }

  setNextAlgorithm(algorithm) {
    if (this.state.nextAlgorithm !== algorithm) {
      this.setState({ nextAlgorithm: algorithm });
    }
  }

  clickedBack() {
    if (this.state.algorithm) {
      this.setState({ algorithm: null });
    } else if (pageNumber === 0) {
      this.props.restart();
    } else {
      pageNumber--;
      if (pageNumber < 3) {
        w["diagnosed_aud"] = "";
        w["diagnosed_boud"] = "";
        w["diagnosed_noud"] = "";
      }
      this.setState({ page: this.getCurrentPage(false) });
    }
  }

  clickedNext() {
    if (!this.checkFlow()) {
      pageNumber++;
      let page = this.getCurrentPage(true);
      var shownAudPopup = this.state.shownAudPopup;
      var shownFentanylPopup = this.state.shownFentanylPopup;
      var visibleFentanylPopup = this.state.visibleFentanylPopup;
      var visibleAudPopup = this.state.visibleAudPopup;
      if (!shownFentanylPopup) {
        if (page.id == "management_initiation" && pageNumber == 1 &&
          w["medication"] == "Buprenorphine" &&
          w["b_medication"] == "Transmucosal buprenorphine") {
              shownFentanylPopup = true;
              visibleFentanylPopup = true;
        }
      } else if (!shownAudPopup) {
        if (page.id == "management_initiation" && pageNumber == 2 &&
          w["medication"] == "Naltrexone" &&
          w["diagnosed_aud"] == "Yes") {
            shownAudPopup = true;
            visibleAudPopup = true;
        }
      }

      w.history.pushState({id: page.id, pageNumber: pageNumber}, null);
      this.setState({ page, shownAudPopup, shownFentanylPopup, visibleFentanylPopup, visibleAudPopup});
    }
  }

  getCurrentPage(forward) {
    let page = null;
    while (page === null) {
      const potentialPage = getAllPagesInSection(this.props.category)[
        pageNumber
      ];
      if (potentialPage && eval(potentialPage.visible)) {
        page = potentialPage;
      } else {
        forward ? pageNumber++ : pageNumber--;
      }
    }
    return page;
  }

  checkFlow() {
    let flowComplete = false;
    const flows = getAllDataInSection(this.props.category).flows;
    flows.forEach((flow) => {
      if (eval(flow.value)) {
        flowComplete = true;
        const algorithm = this.state.nextAlgorithm
          ? this.state.nextAlgorithm
          : flow.algorithm;
        this.setState({ algorithm: algorithm, nextAlgorithm: null });
      }
    });

    return flowComplete;
  }

  buildData() {
    const postCategory = this.state.algorithm
      ? this.state.algorithm
      : this.props.category;

    Object.keys(getAllCategoriesInSection(postCategory)).forEach((category) => {
      this.createCategories(category);
    });

    const visibleQuestions = [];
    const questions = this.state.algorithm
      ? getAllQuestionsInSection(postCategory)
      : getAllQuestionsInPage(this.state.page);

      questions.forEach((question) => {
      if (question.id !== "dsm_oud" && question.id !== "audit_c") {
        var vis = eval(question.visible);
        w[question.id + "_v"] = vis;
        if (vis) {
          visibleQuestions.push(question);
          if (w[question.id] !== null || w[question.id] !== "") {
            questions[question.id] = w[question.id];
          } else if (question.type === "yesno") {
            questions[question.id] = null;
          } else {
            questions[question.id] = "";
          }
        }
      }
    });

    const postContent = [];
    const nonQuestions = this.state.algorithm
      ? getAllPostContentInSection(postCategory)
      : getAllPostContentInPage(this.state.page);

    if (nonQuestions) {
      nonQuestions.forEach((post) => {
        if (eval(post.visible)) {
          postContent.push(post);
          return;
        }
      });
    }

    if (JSON.stringify(this.state.visibleQuestions) !== JSON.stringify(visibleQuestions)) {
      this.setState({ visibleQuestions: visibleQuestions });
    }

    return { postContent: postContent, visibleQuestions: visibleQuestions };
  }

  questionSection() {
    const { visibleQuestions, postContent } = this.buildData();
    this.showNextButton(postContent);
    return (
      <QuestionSection
        visibleQuestions={visibleQuestions}
        title={this.props.title}
        postContent={postContent}
        answerSelected={this.answerSelected}
        tab={"management"}
      />
    );
  }

  algorithmSection() {
    const { postContent } = this.buildData();
    this.showNextButton("");
    return (
      <AlgorithmSection
        algorithm={this.state.algorithm}
        nextAlgorithm={this.setNextAlgorithm}
        answerSelected={this.answerSelected}
        handleButton={this.props.handleButton}
        postContent={postContent}
        tab={"management"}
      />
    );
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState !== this.state) {
      if (
        this.state.visibleQuestions.length &&
        JSON.stringify(this.state.visibleQuestions) !==
          JSON.stringify(nextState.visibleQuestions)
      ) {
        /*this.state.visibleQuestions.forEach((question) => {
          w[question.id + "_v"] = false;
        });
        nextState.visibleQuestions.forEach((question) => {
          w[question.id + "_v"] = true;
        });*/
      }
      return true;
    }
    return false;
  }

  nextButtonStack() {
    let buttonStack = [];

    if (w["diagnosed_aud"] === "I don't know") {
      buttonStack.push(
        <button
          id="audit_c"
          className="next btn btn-primary management"
          type="submit"
          value="Next &gt;"
          onClick={this.props.confirmationTool}
        >
          Go to AUD for confirmation &gt;
        </button>
      );
    }

    if (
      w["diagnosed_boud"] === "I don't know" ||
      w["diagnosed_noud"] === "I don't know"
    ) {
      buttonStack.push(
        <button
          id="dsm_oud"
          className="next btn btn-primary management"
          type="submit"
          value="Next &gt;"
          onClick={this.props.confirmationTool}
        >
          Go to DSM-5 for confirmation &gt;
        </button>
      );
    }

    if (buttonStack.length) {
      return (
        <div className="btn-group-vertical custom-btn-group">
          {buttonStack.map((button) => button)}
        </div>
      );
    } else {
      return (
        <button
          id="management_next"
          className="next btn btn-primary management"
          type="submit"
          value="Next &gt;"
          onClick={this.clickedNext}
        >
          Next &gt;
        </button>
      );
    }
  }

  dismissModal(id) {
    if (id == 'fentanyl') {
       this.setState({visibleFentanylPopup: false});
    } else if (id == 'aud') {
      this.setState({visibleAudPopup: false});
    }
  }

  disclaimerModal(id) {
    const info = {
      fentanyl: 'Guidance for best practices is rapidly changing due to the increased risk of precipitated withdrawal for patients using fentanyl. Information will be updated as new evidence becomes available.',
      aud: 'Naltrexone does not treat symptoms of alcohol withdrawal. Alcohol withdrawal can be severe and life threatening. It is imperative to utilize clinical judgement to determine if a patient is medically stable to undergo treatment in an outpatient setting prior to initiating treatment.'
    };

    const text = {
      'title': '',
      'paragraphs': [info[id]],
    }
    return (
      <Modal
        show={true}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>{text.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {text.paragraphs.map((p) => (
            <p>{p}</p>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={ () => this.dismissModal(id) }
            style={{ backgroundColor: "#5368D3" }}
          >
            Accept
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {

    return (
      <div>
        {this.state.visibleAudPopup ? this.disclaimerModal('aud') : ""} {this.state.visibleFentanylPopup ? this.disclaimerModal('fentanyl') : ""}
        <div id="management_form" className="form card-holder">
          {this.state.algorithm
            ? this.algorithmSection()
            : this.questionSection()}
          <button
            id="management_back"
            className="back btn btn-secondary"
            value="&lt; Back"
            onClick={this.clickedBack}
          >
            &lt; Back
          </button>
          {next ? this.nextButtonStack() : null}
        </div>
      </div>
    );
  }
}

export default ManagementFlow;
